export default "__VITE_ASSET__CGGMTvwD__"